import { Pill } from '@/components/ui/pill'

// Per-leg flight-assignment acceptance state (TripLegCrew.acknowledged),
// shown on trip/leg crew lists (Figma "Flight/Trip Acceptence").
export function CrewAcceptanceBadge({ accepted }: { accepted: boolean }) {
  return accepted ? (
    <Pill variant="success">Accepted</Pill>
  ) : (
    <Pill variant="warning">Pending</Pill>
  )
}
